import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
     const [loading, setLoading] = useState(true);
     const [allowed, setAllowed] = useState(false);

     useEffect(() => {
          const auth = getAuth();


          const unsub = onAuthStateChanged(auth, async (user) => {
               if (user) {
                    try {
                         // 🔥 Get fresh token with claims
                         const tokenResult = await user.getIdTokenResult(true);

                         if (tokenResult.claims.role === "admin") {
                              setAllowed(true);
                         } else {
                              setAllowed(false);
                         }
                    } catch (error) {
                         console.error("Role check error:", error);
                         setAllowed(false);
                    }
               } else {
                    setAllowed(false);
               }

               setLoading(false);
          });

          return () => unsub();
     }, []);

     if (loading) return null; // ya loader dikha do

     return allowed ? children : <Navigate to="/" replace />;
};

export default AdminRoute;